import { Button } from "@/components/ui/button";
import { MapPin, Utensils, Link, File } from "lucide-react";
import { FoodDrinksActivity } from "../models/activity.model";
import { BaseActivityCard } from "./BaseActivityCard";
import { DocumentationList } from "@/components/ui/documentation-list";
import { MediaGallery } from "@/components/ui/media-gallery";

interface FoodDrinksCardProps {
  activity: FoodDrinksActivity;
  onEdit: (activity: FoodDrinksActivity) => void;
  onDelete: (activity: FoodDrinksActivity) => void;
  onDuplicate?: (activity: FoodDrinksActivity) => void;
  onExpand?: () => void;
  isReadOnly?: boolean;
}

export const FoodDrinksCard = ({
  activity,
  onEdit,
  onDelete,
  onDuplicate,
  onExpand,
  isReadOnly = false
}: FoodDrinksCardProps) => {
  const renderAlwaysVisible = () => (
    <>
      {/* Description */}
      {activity.description && (
        <p className="text-sm text-gray-600 leading-relaxed">{activity.description}</p>
      )}
    </>
  );

  const renderCollapsible = () => (
    <>

      {/* Media Gallery */}
      <MediaGallery media={activity.media || []} />

      {/* Documentation */}
      <DocumentationList documentation={activity.documentation || []} />

      {/* Action Buttons */}
      <div className="flex items-center justify-between">
        <div className="flex gap-3">
          {/* Link Button */}
          {activity.link && (
            <Button
              variant="ghost"
              size="sm"
              className="rounded-xl"
              onClick={() => window.open(activity.link, '_blank')}
            >
              <Link className="h-5 w-5 mr-2 flex-shrink-0" />
              <span className="truncate max-w-[200px] inline-block">
                {activity.link}
              </span>
            </Button>
          )}
        </div>
      </div>
    </>
  );

  return (
    <BaseActivityCard
      activity={activity}
      onEdit={onEdit}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onExpand={onExpand}
      isReadOnly={isReadOnly}
    >
      {{
        alwaysVisible: renderAlwaysVisible(),
        collapsible: renderCollapsible()
      }}
    </BaseActivityCard>
  );
};
